export interface ContractActivity {
  activityUID: string;
  contractUID: string;
  date: Date;
  action: ContractActionType;
  description: string;
  details?: ActivityDetails;
  performedBy: string; // User UID or 'system' for automated actions
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  metadata?: Record<string, any>;
  createdAt: Date;
}

/**
 * Single document structure for contract activities
 * Stores all activities in a single document to minimize reads
 */
export interface ContractActivitiesDocument {
  contractUID: string;
  activities: ContractActivity[];
  totalCount: number;
  lastUpdated: Date;
  version: string;
  createdAt: Date;
}

export enum ContractActionType {
  // Payment related
  PAYMENT_RECEIVED = 'payment_received',
  PAYMENT_CANCELLED = 'payment_cancelled',
  PAYMENT_REQUEST_SENT = 'payment_request_sent',
  PAYMENT_REMINDER_SENT = 'payment_reminder_sent',
  PARTIAL_PAYMENT_COMPLETED = 'partial_payment_completed',
  
  // Deposit related
  DEPOSIT_RECEIVED = 'deposit_received',
  DEPOSIT_RELEASED = 'deposit_released',
  
  // Contract lifecycle
  CONTRACT_CREATED = 'contract_created',
  CONTRACT_SIGNED = 'contract_signed',
  CONTRACT_STARTED = 'contract_started',
  CONTRACT_UPDATED = 'contract_updated',
  CONTRACT_TERMINATED = 'contract_terminated',
  CONTRACT_RENEWED = 'contract_renewed',
  TERMINATION_NOTIFICATION_SENT = 'termination_notification_sent',
  
  // Document related
  DOCUMENT_GENERATED = 'document_generated',
  DOCUMENT_SENT = 'document_sent',
  
  // Maintenance related
  MAINTENANCE_SCHEDULED = 'maintenance_scheduled',
  REPAIR_REQUESTED = 'repair_requested',
  
  // Indexation related
  INDEXATION_PLANNED = 'indexation_planned',
  INDEXATION_NOTIFICATION_SENT = 'indexation_notification_sent',
  INDEXATION_APPLIED = 'indexation_applied',
  INDEXATION_CONFIRMED = 'indexation_confirmed',
  INDEXATION_REJECTED = 'indexation_rejected',
  INDEXATION_CANCELLED = 'indexation_cancelled',
  INDEXATION_DELETED = 'indexation_deleted',
  RENT_INCREASE = 'rent_increase',
  
  // Other
  NOTE_ADDED = 'note_added',
  STATUS_CHANGED = 'status_changed'
}

export interface ActivityDetails {
  // Payment specific
  amount?: number;
  currency?: string;
  paymentMethod?: string;
  paymentPeriod?: {
    startDate: Date;
    endDate: Date;
  };
  
  // Document specific
  documentType?: string;
  documentFormat?: string;
  documentUID?: string;
  
  // Indexation specific
  indexationType?: string;
  baseIndexValue?: number;
  newIndexValue?: number;
  indexationRate?: number;
  previousRentAmount?: number;
  newRentAmount?: number;
  effectiveDate?: Date;
  indexationCap?: number;
  actualIncrease?: number;
  paymentsUpdated?: boolean;
  
  // Contract specific
  contractType?: string;
  propertyUID?: string;
  tenantUID?: string;
  contractDate?: Date;
  startDate?: Date;
  endDate?: Date;
  terminationDate?: Date;
  noticeGiven?: Date;
  
  // General
  previousValue?: unknown;
  newValue?: unknown;
  reason?: string;
  automaticAction?: boolean;
} 